import { GridApi } from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { EditSizePopupComponent } from "../edit-size-popup/edit-size-popup.component";
import { Subject } from "rxjs";

@Component({
  selector: "app-size-cell-renderer",
  templateUrl: "./size-cell-renderer.component.html",
  styleUrls: ["./size-cell-renderer.component.scss"],
})
export class SizeCellRendererComponent implements OnDestroy {
  params;
  data: any;
  gridApi:GridApi;
  private destroy$ = new Subject<void>();
constructor(private dialog:MatDialog){}

  agInit(params:any): void {
    this.params = params;
    this.data = this.params.data;
    this.gridApi = params.api;
  }

  edit() {
    this.dialog.open((EditSizePopupComponent), {
      width: "600px",
      data: this.data
    }).afterClosed()
      .subscribe((res) => {
       /* if (res === "Save") {
          this.gridApi?.refreshServerSide({ route: [], purge: true });
        }*/
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
